module.exports = __webpack_public_path__ + "static/media/five-tips-for-data-science-interviews.f401f4a6.md";